import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { getBanners } from '../../actions/messageActions'
import { getRemainingTime, millisToMinutesAndSeconds, padNum, getUrlParamQueries, formatCurrency } from '../../utils'
import { setTimeRemaining } from 'actions/eventsAction'

class Header extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.props = props;
    }

    componentWillUnmount() {
        this._isMounted = false;
      }

    componentDidMount() {
        this._isMounted = true;
        setTimeout(() => { if (this.props.endings !== '') { this.runTimer(); } }, 100);
        setInterval(() => { if (this.props.endings !== '') { this.runTimer(); } }, 1000);
    }

    runTimer() {
        if (this._isMounted) {
          const timeRemaining = millisToMinutesAndSeconds(getRemainingTime(this.props.endings[this.props.jackpot.name]))
          this.props.setTimeRemaining(timeRemaining)
        }
    }

    render() {

        let balance = '';
        if(typeof this.props.balance !== "undefined"){
          if(this.props.balance.length > 0){
              balance = this.props.balance[0].balance;
          }
          }
          if(getUrlParamQueries()['loggedIn'] == 'false'){
            balance=0;
          }

        return (
            <header className="bg-header">
                <Row className="no-gutters">
                    {/* <Col xs="12" md="12" className="d-none d-md-block">
                        <img src="/assets/banners/BW_SA_Jackpots_DesktopTopBanner.jpg" className="w-100" />
                    </Col> */}
                    {/* <Col sm={12} className="d-sm-block d-md-none">
                        <img src="/assets/banners/BW_SA_Jackpots_MobileTopBanner.jpg" className="w-100" />
                    </Col> */}
                    <Col xs="12" md="12">
                        <Row className="no-gutters bg-grey">
                            <Col md="12" className="text-center">
                                <div className="header-content">
                                    <img className="header-content-c icon-clock" src="/assets/icons/icon_timer.svg" />
                                    <div className="header-content-c countdown-col">
                                    {(this.props.gamesList !== '' && Object.keys(this.props.gamesList).length > 0) &&
                                        <React.Fragment>
                                            <span className={ (this.props.timeRemaining === '' ? '' : 'betbar-countdown-header')}>
                                                  {this.props.timeRemaining}
                                              </span>
                                              <br/>
                                            <span className="betbar-countdown-header-text">UNTIL TODAY'S JACKPOT CLOSES</span>
                                        </React.Fragment>
                                      }
                                    </div>
                            </div>
                            </Col>

                            <Col md="12" className="text-center">
                            <Row className="competition-info">
                            <Col xs="0" md={3}></Col>
                            <Col xs="6" md={3}>
                            <div className="input-group my-2">
                                <div className="input-group-prepend">
                                <span className="input-group-text">AVAILABLE TICKETS:</span>
                                </div>
                                <input type="text" disabled className="form-control" value={balance!=''?padNum(balance):'0'}/>
                            </div>
                            </Col>
                            <Col xs="6" md={3}>
                                {(this.props.gamesList != '' && Object.keys(this.props.gamesList).length > 0) &&
                            <div className="input-group my-2">
                                <div className="input-group-prepend">
                                <span className="input-group-text">JACKPOT PRIZE:</span>
                                </div>
                                <input type="text" disabled className="form-control"
                                    value={formatCurrency(this.props.gamesList["multi-market"][0]['jackpot'])}/>
                            </div>}
                            </Col>
                            </Row>
                            </Col>
                        </Row>

                   
                    </Col>
                </Row>
            </header>
        );
    }
}

function mapStateToProps(state) {
    return {
        gamesList: state.eventsReducer.gamesList,
        banners: state.messageReducer.banners,
        endings: state.eventsReducer.endings,
        timeRemaining: state.eventsReducer.timeRemaining,
        balance: state.balanceReducer.balance
    }
}

export default connect(mapStateToProps, { getBanners, setTimeRemaining })(Header);



// WEBPACK FOOTER //
// ./components/Header/index.js